import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { ReactionViewerSheet } from "@/components/social/reactions/ReactionViewerSheet";

/**
 * "14 Reactions" — a navigation control on the engagement row, NOT a reaction button.
 * Hidden at zero. Renders the viewer itself so posts and comments share one integration.
 */
export function ReactionCountButton({ reactions = {}, target, testId, openEmoji, onOpenChange }) {
  const [open, setOpen] = useState(false);
  const [emoji, setEmoji] = useState(null);
  const total = Object.values(reactions || {}).reduce((a, b) => a + (b || 0), 0);

  // Lets a hover preview's "+N others" open this same viewer, pre-filtered.
  const externalOpen = openEmoji !== undefined && openEmoji !== null;
  const isOpen = open || externalOpen;
  const change = (v) => {
    setOpen(v);
    if (!v) onOpenChange?.(null);
  };

  if (total <= 0) return null;
  return (
    <>
      <Button
        variant="ghost" size="sm"
        onClick={() => { setEmoji(null); setOpen(true); }}
        aria-label={`See who reacted — ${total} ${total === 1 ? "reaction" : "reactions"}`}
        data-testid={testId}
      >
        {total} Reaction{total === 1 ? "" : "s"}
      </Button>
      {isOpen && (
        <ReactionViewerSheet
          open={isOpen} onOpenChange={change} target={target}
          initialEmoji={externalOpen ? openEmoji : emoji} summary={reactions}
        />
      )}
    </>
  );
}

export default ReactionCountButton;
